import { anyOf, arrayOf, maybe, objectOf, recordOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, string, unknown } from "@altostra/type-validations/lib/primitives";

export const isOperatorMcpTool = objectOf({
  name: string,
  title: anyOf(string, nullOrUndefined),
  description: string,
  input_schema: recordOf(unknown),
  read_only: boolean,
  destructive: boolean,
  idempotent: boolean,
});

export const isOperatorMcpConnectionTools = objectOf({
  id: string,
  name: string,
  display_name: string,
  server_url: string,
  connected: boolean,
  tools: arrayOf(isOperatorMcpTool),
  authorization_url: maybe(string),
  error: maybe(string),
});

export const isGetAppGroupIdOperatorMcpConnectionsToolsResult = objectOf({
  connections: arrayOf(isOperatorMcpConnectionTools),
});
